import { $http, $pag } from './index';
import { LoginFormProp } from '../types/login';
// import axios from 'axios';

const login = (data: LoginFormProp) => {
  return $http({ url: '/login', method: 'post', data });
};

const getDeveloper = () => {
  return $http({ url: '/developer/getDeveloper', method: 'get' });

  // {withCredentials: true}
};

const acceptQCToken = (params: any) => {
  return $http({ url: '/acceptQCToken', method: 'post', params });
};

const QCToken = (params: any) => {
  return $http({
    url: '/developer/acceptQCToken',
    method: 'post',
    data: params
  });
};
// const QCToken = (data: any) => {
//   return $http({ url: "/acceptQCToken", method: 'post', data })
// }

// QCUserInfo
const QCUserInfo = () => {
  return $http({ url: '/QCUserInfo', method: 'get' });
};

/**
 * @description: 接口联调
 */
const deveLogin = (params: any) => {
  return $http({ url: '/developer/login', method: 'post', data: params });
};

const filepag = (formData: any) => {
  return $pag({ url: '/filepag', method: 'post', data: formData });
};

const softwareCosPag = (formData: any) => {
  return $pag({ url: '/softwareCosPag', method: 'post', data: formData });
};

const addDeveloper = (params: any) => {
  return $http({
    url: '/developer/addDeveloper',
    method: 'post',
    data: params
  });
};
const editDeveloper = (params: any) => {
  return $http({
    url: '/developer/editDeveloper',
    method: 'post',
    data: params
  });
};

const getSoftwareList = () => {
  return $http({ url: '/software/getSoftwareList', method: 'get' });
};

const getApprovalRecord = () => {
  return $http({ url: '/developer/getApprovalRecord', method: 'get' });
};

const addSoftware = (params: any) => {
  return $http({ url: '/software/addSoftware', method: 'post', data: params });
};

const addSoftwareDraft = (params: any) => {
  return $http({
    url: '/software/addSoftwareDraft',
    method: 'post',
    data: params
  });
};

const getSoftwareDetailById = (params: any) => {
  return $http({
    url: '/software/getSoftwareDetailById',
    method: 'post',
    data: params
  });
};

const excludeVersion = (params: any) => {
  return $http({
    url: '/software/excludeVersion',
    method: 'post',
    data: params
  });
};

const takeDownSoftware = (params: any) => {
  return $http({
    url: '/software/takeDownSoftware',
    method: 'post',
    data: params
  });
};

// whetherNewSoftware
const whetherNewSoftware = (params: any) => {
  return $http({
    url: '/software/whetherNewSoftware',
    method: 'post',
    data: params
  });
};

// undoApprove
const undoApprove = (params: any) => {
  return $http({ url: '/software/undoApprove', method: 'post', data: params });
};

const updateSoftware = (params: any) => {
  return $http({
    url: '/software/updateSoftware',
    method: 'post',
    data: params
  });
};

const addNewVersion = (params: any) => {
  return $http({
    url: '/software/addNewVersion',
    method: 'post',
    data: params
  });
};

const getUserSoftware = () => {
  return $http({
    url: '/software/getUserSoftList',
    method: 'post',
    data: {}
  });
};

const getSoftwareRecord = (params: any) => {
  return $http({
    url: '/software/getSoftwareRecord',
    method: 'post',
    data: params
  });
};

const getSoftwareByCode = (params: any) => {
  return $http({
    url: '/software/getSoftwareByCode',
    method: 'post',
    data: params
  });
};

const getInlineSoftware = (params: any) => {
  return $http({
    url: '/software/getInlineSoftware',
    method: 'post',
    data: params
  });
};

// 验证码接口 verify
const getAuthCode = (params: any) => {
  return $http({
    url: '/forward/getOrVerifyCode',
    method: 'post',
    data: params
  });
};

// 扫码实名认证
const confirmRealName = (params: any) => {
  return $http({
    url: '/forward/confirmRealName',
    method: 'post',
    data: params
  });
};

// 扫码实名认证
const confirmLicense = (params: any) => {
  return $http({
    url: '/forward/confirmLicense',
    method: 'post',
    data: params
  });
};

const ensureOneCompany = (params: any) => {
  return $http({
    url: '/developer/ensureOneCompany',
    method: 'post',
    data: params
  });
};


const getAdPlanList = (params: {
  page: number,
  pageSize: number,
}) => {
  return $http({
    url: '/advertise/getAdPlanList',
    method: 'post',
    data: params
  });
}

const getEnumAdvertiseList = () => {
  return $http({
    url: '/advertise/getAdvertiseList',
    method: 'get',
  });
}

const addAdvertisePlan = (params: any) => {
  return $http({
    url: '/advertise/addAdvertisePlan',
    method: 'post',
    data: params,
  })
}

const editAdvertisePlan = (params: any) => {
  return $http({
    url: '/advertise/editAdvertisePlan',
    method: 'post',
    data: params,
  })
}

const getAdvertiseInfo = (params: {plan_id: number}) => {
  return $http({
    url: '/advertise/getAdvertisePlanInfo',
    method: 'get',
    params: params
  })
}

export {
  login,
  getDeveloper,
  acceptQCToken,
  QCUserInfo,
  QCToken,

  // 接口联调
  deveLogin,
  addDeveloper,
  editDeveloper,
  getSoftwareList,
  getApprovalRecord,
  addSoftware,
  addSoftwareDraft,
  getSoftwareDetailById,
  excludeVersion,
  getSoftwareRecord,
  updateSoftware,
  addNewVersion,
  getUserSoftware,
  getSoftwareByCode,
  getInlineSoftware,
  takeDownSoftware,
  whetherNewSoftware,
  undoApprove,
  getAuthCode,
  confirmRealName,
  confirmLicense,
  filepag,
  softwareCosPag,
  ensureOneCompany,

  getAdPlanList,
  getEnumAdvertiseList,
  addAdvertisePlan,
  editAdvertisePlan,
  getAdvertiseInfo,
};

// export const login = (data: LoginFormProp) => $http({ url: "/login", method: 'post', data })
